import * as React from "react";

var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function SvgBd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "flag-icons-bd",
    viewBox: "0 0 640 480",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#006a4e",
    d: "M0 0h640v480H0z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 280,
    cy: 240,
    r: 160,
    fill: "#f42a41"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBd);
export default ForwardRef;
export { ForwardRef as ReactComponent };